import { FC, ReactNode, useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

type TooltipProps = {
  label: string;
  children: ReactNode;
  position?: 'top' | 'bottom';
  className?: string;
};

const Tooltip: FC<TooltipProps> = ({
  label,
  children,
  position = 'top',
  className = '',
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [coords, setCoords] = useState<{ top: number; left: number }>({
    top: 0,
    left: 0,
  });
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isVisible && ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setCoords({
        top: position === 'top' ? rect.top - 28 : rect.bottom + 8,
        left: rect.left + rect.width / 2,
      });
    }
  }, [isVisible, position]);

  return (
    <div
      ref={ref}
      className={`inline-flex items-center ${className}`}
      onPointerEnter={(e) => e.pointerType !== 'touch' && setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible
        ? createPortal(
            <div
              className="fixed z-[9999] pointer-events-none transform -translate-x-1/2 bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap shadow-sm transition-opacity duration-150"
              style={{
                top: coords.top,
                left: coords.left,
              }}
            >
              {label}
            </div>,
            document.body
          )
        : null}
    </div>
  );
};

export default Tooltip;
